import _ from 'lodash';
import React from 'react';
import styled from 'styled-components';
import FundsContext from './context';
import { Container } from '../../shared/styles';
import Loading from '../../../../shared/loading';
import Fund from './view-modal-components/fund';
import Errors from './view-modal-components/errors';
import {
  createFund,
} from '../../../../services/lwadmin/fund/fund-service';

const Article = styled.article`
  display: flex;
  flex-direction: column;
`;

const Title = styled.span`
  text-transform: uppercase;
  font-size: 14px;
  line-height: 120%;
  font-family: ${props => props.theme.fontFamilyBody};
  font-weight: ${props => props.theme.fontWeightHeavy};
`;

const Subtitle = styled.span`
  font-size: 12px;
  line-height: 120%;
  font-family: ${props => props.theme.fontFamilyBody};
`;

const FundContainer = styled.div`
  border-top: 1px solid ${props => props.theme.secondaryColorLight};
  border-bottom: 1px solid ${props => props.theme.secondaryColorLight};
  margin: 16px 0;
`;

const ButtonContainer = styled(Container)`
  justify-content: flex-end;
`;

const ImportButton = styled.button`
  text-transform: uppercase;
  font-size: 14px;
  line-height: 120%;
  font-family: ${props => props.theme.fontFamilyBody};
  font-weight: ${props => props.theme.fontWeightHeavy};
  color: #fff;
  border: 1px solid #C19D3F;
  background-color: ${props => props.theme.btnPrimaryBackgroundColor};
  border-radius: 2px;
  height: 42px;
  width: 147px;
  margin-left: 16px;
`;

const CancelButton = styled(ImportButton)`
  background-color: ${props => props.theme.btnSecondaryBackgroundColor};
`;

/* eslint-disable complexity */
export default function ViewModal() {
  const {
    state: { showViewModal, viewFund },
    dispatch,
  } = React.useContext(FundsContext);
  const [loading, setLoading] = React.useState(false);

  const overlayRef = React.useRef();
  const modalRef = React.useRef();
  const loadingRef = React.useRef();

  const dismiss = e => {
    e && e.preventDefault();
    dispatch({ type: 'dismissViewModal' });
  };

  const modalDismiss = e => {
    e && e.preventDefault();
    e.target === modalRef.current && dismiss();
  };

  const handleCancel = e => {
    e && e.preventDefault();
    dismiss(e);
    dispatch({ type: 'importFund' });
  };

  const handleImport = e => {
    e && e.preventDefault();

    const payload = {
      name: viewFund.dpFundName,
      data_provider_id: viewFund.dpFundId,
      apir_code: viewFund.dpFundApir,
      isin: viewFund.dpFundIsin,
      inception_date: viewFund.dpFundInceptionDate,
      minimum_investment: viewFund.dpFundMinimumInvestment || null,
      currency: viewFund.dpFundCurrency,
      legal_structure: viewFund.dpFundLegalStructure,
      domicile: viewFund.dpFundDomicile,
      fund_investor_vehicle_type: viewFund.dpFundInvestmentVehicleType,
      dp_category: viewFund.dpFundCategory,
      geographical_focus: viewFund.geographicalFocus,
      stock_code: viewFund.dpStockCode,
      stock_exchange: viewFund.dpStockExchange,
      fund_type: viewFund.dpFundType,
    };

    setLoading(true);
    createFund(payload).then(async resp => {
      setLoading(false);
      const createdId = _.get(resp, 'data.id');
      window.location = `/lwadmin/fund/${createdId}/edit?auto_sync_data=true`;
    }).catch(error => {
      setLoading(false);
      dispatch({ type: 'setErrors', payload: _.get(error, 'response.data', {}) });
    });
  };

  React.useEffect(() => {
    if (showViewModal) {
      $(modalRef.current).fadeIn();
      $(overlayRef.current).fadeIn();
      dispatch({ type: 'setErrors', payload: {} });
    } else {
      $(overlayRef.current).fadeOut();
      $(modalRef.current).fadeOut({ complete: () => dispatch({ type: 'dismissViewModal' }) });
    }
  }, [showViewModal, dispatch]);

  React.useEffect(() => (loadingRef.current.toggle(loading)), [loading]);

  return (
    <div>
      <div className="modal-overlay" role="region" ref={overlayRef} onClick={dismiss} />
      <div className="modal --large" tabIndex="-1" role="dialog" ref={modalRef} onClick={modalDismiss}>
        <Article>
          <Title>confirm data import</Title>
          <Subtitle>
            Below is a list of the fields which will be updated with data imported from our
            data provider. Please confirm before importing.
          </Subtitle>
          <FundContainer>
            {!!viewFund && <Fund fund={viewFund} />}
          </FundContainer>
          <ButtonContainer>
            <CancelButton onClick={handleCancel}>cancel</CancelButton>
            <Loading ref={loadingRef} variant="button">
              <ImportButton onClick={handleImport}>import</ImportButton>
            </Loading>
          </ButtonContainer>
          <Errors />
        </Article>
      </div>
    </div>
  );
}
/* eslint-enable complexity */
